export const splitMatcher = (value: string, matcher: number, matcherLen: number) => {
  const safeValue = value ?? ''
  if (matcher === null || matcher === undefined || matcher === -1 || matcher > safeValue.length - 1) {
    return [safeValue, '', '']
  }

  return [
    safeValue.slice(0, matcher), 
    safeValue.slice(matcher, matcherLen + matcher), 
    safeValue.slice(matcherLen + matcher)
  ]
}